import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { legacyTourTarget, type LegacyTarget } from "./legacy-redirects";

/**
 * Resolves a legacy WordPress `/tours/{slug}` path against the live catalog.
 * Read-only: never mutates data, and degrades to a catalog search target when
 * the catalog is unavailable.
 */
export const resolveLegacyTourSlug = createServerFn({ method: "GET" })
  .inputValidator(z.object({ slug: z.string().min(1).max(200) }))
  .handler(async ({ data }): Promise<LegacyTarget> => {
    let slugs: string[] = [];
    try {
      const { listUnifiedCatalog } = await import("./catalog.functions");
      const catalog = await listUnifiedCatalog({ data: { lang: "es" } });
      slugs = (catalog.tours ?? []).map((t) => t.slug).filter(Boolean);
    } catch {
      // Catalog unreachable → fall back to the alias map + query target.
    }
    return legacyTourTarget(data.slug, slugs);
  });
